module.exports = __webpack_public_path__ + "262c262217eb34803b099c52c422e969.svg";